export const FETCH_PROFILE_REQUEST = 'FETCH_PROFILE_REQUEST';
export const FETCH_PROFILE_SUCCESS = 'FETCH_PROFILE_SUCCESS';
export const FETCH_PROFILE_FAILURE = 'FETCH_PROFILE_FAILURE';
export const UPDATE_PROFILE_PHOTO_REQUEST = 'UPDATE_PROFILE_PHOTO_REQUEST';
export const UPDATE_PROFILE_PHOTO_SUCCESS = 'UPDATE_PROFILE_PHOTO_SUCCESS';
export const UPDATE_PROFILE_PHOTO_FAILURE = 'UPDATE_PROFILE_PHOTO_FAILURE';
export const UPDATE_PROFILE_REQUEST = 'UPDATE_PROFILE_REQUEST';
export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS';
export const UPDATE_PROFILE_FAILURE = 'UPDATE_PROFILE_FAILURE';
export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAILURE = 'CHANGE_PASSWORD_FAILURE';
export const ADD_PORT_REQUEST = 'ADD_PORT_REQUEST';
export const ADD_PORT_SUCCESS = 'ADD_PORT_SUCCESS';
export const ADD_PORT_FAILURE = 'ADD_PORT_FAILURE';
export const FETCH_SUBSCRIPTIONS_REQUEST = 'FETCH_SUBSCRIPTIONS_REQUEST';
export const FETCH_SUBSCRIPTIONS_SUCCESS = 'FETCH_SUBSCRIPTIONS_SUCCESS';
export const FETCH_SUBSCRIPTIONS_FAILURE = 'FETCH_SUBSCRIPTIONS_FAILURE';
export const UPDATE_SUBSCRIPTION_STATUS_REQUEST = 'UPDATE_SUBSCRIPTION_STATUS_REQUEST';
export const UPDATE_SUBSCRIPTION_STATUS_SUCCESS = 'UPDATE_SUBSCRIPTION_STATUS_SUCCESS';
export const UPDATE_SUBSCRIPTION_STATUS_FAILURE = 'UPDATE_SUBSCRIPTION_STATUS_FAILURE';